/* eslint-disable */
require.config({
  shim: {
    'js/angularjs/1.5.8/angular': {
      deps: ['js/jquery/2.1.3/jquery.min'],
      exports: 'angular'
    },
    'js/aofl-js/0.8.0/app/app': {
      deps: ['js/angularjs/1.5.8/angular']
    }
  },
  map: {
    '*': {
      angular: 'js/angularjs/1.5.8/angular'
    }
  }
});
/* eslint-enable */

define([/* eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'js/angularjs/1.5.8/angular',
  'js/aofl-js/0.8.0/app/app-version',
  'js/aofl-js/0.8.0/app/app-init',
  'js/aofl-js/0.8.0/app/app-debug',
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min',
  'js/aofl-js/0.8.0/compile-service/0.1/index',
  'js/aofl-js/0.8.0/state-configuration-service/index',
  'js/aofl-js/0.8.0/time-formatter-service/0.1/index'
  /* eslint-enable */
], function aofljsAMD(app, angular, appVersion, appInit, appDebug, aoflModules) {
  'use strict';
  var APPLICATION_VERSION_KEY = 'applicationVersion';
  var initInjector = angular.injector(['ng']);
  var $window = initInjector.get('$window');

  appDebug.addGlobalDebugControls($window);

  /**
   * Bootstraps angular and returns a promise that when resolved returns app and
   * $injector
   *
   * @return {Object} $q({app, $injector})
   */
  var bootstrapAngular = function bootstrapAngular() {
    return new Promise(function(_resolve) {
      var element = angular.element(document);
      element.ready(function() {
        var $injector = angular
        .bootstrap(document, [app.name, function() {
          element
          .find('html')
          .addClass('ng-app');
        }], {
          strictDi: true
        });
        _resolve({
          app: app,
          injector: $injector
        });
      });
    });
  };

  /**
   * This is the exported function of the aofljs module, which is invoked by
   * an application's main.js script.
   *
   * @param {Object} options  An object with the following properties:
   *
   * {
   *   applicationId             : {String},
   *   applicationVersion        : {String},
   *   applicationRootPath       : {String},
   *   applicationRootDir        : {String},
   *   webServiceRootPath        : {String},
   *   states                    : {Object},
   *   productionWebServiceHosts : {Object},
   *   html5Mode                 : {Boolean},
   *   applicationDebug          : {Boolean},
   *   preventInitialRouteTransfer: {Boolean}
   * }
   *
   * @return {Object} $q({app, $injector})
   */
  var appBootstrap = function appBootstrap(options) {
    var applicationPathName = document.location.pathname;
    var applicationBasePath = applicationPathName +
    (options.html5Mode ? '/' : '#');
    var applicationDebug = appDebug.setDebugMode(options.applicationDebug);
    if (applicationPathName && applicationPathName[applicationPathName.length - 1] !== '/') {
      // eslint-disable-next-line
      applicationPathName = applicationPathName + '/';
    }
    app.constant('applicationId', options.applicationId);
    app.constant('applicationVersion', options.applicationVersion);
    app.constant('applicationRootPath', options.applicationRootPath);
    app.constant('applicationRootDir', options.applicationRootDir);
    app.constant('applicationPathName', applicationPathName);
    app.constant('applicationBasePath', applicationBasePath);
    app.constant('html5Mode', options.html5Mode);
    app.constant('states', options.states);
    app.constant('appOptions', options);
    app.constant('applicationDebug', applicationDebug);

    localStorage.setItem(APPLICATION_VERSION_KEY, options.applicationVersion);

    appInit(options);
    return aoflModules.ready.then(bootstrapAngular);
  };

  return appBootstrap;
});
